import { TASKS } from "./index";
import { IS_FINISHED } from "./initialState";

export const isFinished = state => state.getIn([TASKS, IS_FINISHED]);

export default {};